import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var EducationApp = function EducationApp(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColor = _ref$secondaryColor === void 0 ? '#FFD32A' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.9999 20.1834L6.5166 16.0001L15.9999 11.8584L25.4833 16.0001L15.9999 20.1834ZM9.83327 16.0001L15.9999 18.7251L22.1666 16.0001L15.9999 13.3084L9.83327 16.0001Z",
      fill: !ignoreColor ? secondaryColor : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.33333 16.2166H8V23.3332H9.33333V16.2166Z",
      fill: !ignoreColor ? secondaryColor : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.9999 25.3333C14.0665 25.3333 12.2415 24.5833 10.8582 23.2333L10.6582 23.0333L10.6665 17.3916H11.9999V22.4666C13.0999 23.4583 14.5165 23.9999 16.0082 23.9999C17.4999 23.9999 18.9082 23.4583 20.0082 22.4749V17.3999H21.3415V23.0416L21.1415 23.2416C19.7499 24.5916 17.9332 25.3333 15.9999 25.3333Z",
      fill: !ignoreColor ? secondaryColor : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M29.3332 29.3334H2.6665V4.66675C2.6665 3.56675 3.5665 2.66675 4.6665 2.66675H27.3332C28.4332 2.66675 29.3332 3.56675 29.3332 4.66675V29.3334ZM3.99984 28.0001H27.9998V4.66675C27.9998 4.30008 27.6998 4.00008 27.3332 4.00008H4.6665C4.29984 4.00008 3.99984 4.30008 3.99984 4.66675V28.0001Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.6668 5.33325H25.3335V6.66658H26.6668V5.33325Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M23.9998 5.33325H22.6665V6.66658H23.9998V5.33325Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.3333 5.33325H20V6.66658H21.3333V5.33325Z",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("path", {
      d: "M28.6668 8H3.3335V9.33333H28.6668V8Z",
      fill: !ignoreColor ? color : undefined
    })]
  });
};
export default EducationApp;